export function setLigne(ligneName) {
	console.log(`Ligne sélectionnée : ${ligneName}`)
	localStorage.setItem('ligne', ligneName)
}

export function getLigne() {
	let ligne = localStorage.getItem('ligne')
	return ligne ? ligne : '1'
}

export function setDirection(direction) {
	console.log(`Direction sélectionnée : ${direction}`)
	localStorage.setItem('direction', direction)
}

export function getDirection() {
	let direction = localStorage.getItem('direction')
	return direction ? direction : 'Aller'
}

export function getService() {
	let service = localStorage.getItem('service')
	return service ? service : null
}

export function setService(serviceName) {
	console.log(`Service sélectionné : ${serviceName}`)
	localStorage.setItem('service', serviceName)
}
